export const TOKEN_KEY = "mwcrm_token";

const TR_MAP = { i: "İ", ı: "I", ğ: "Ğ", ü: "Ü", ş: "Ş", ö: "Ö", ç: "Ç" };

export function trUpper(v) {
  if (v === null || v === undefined) return v;
  const s = String(v).replace(/[iığüşöç]/g, (c) => TR_MAP[c] || c);
  return s.toUpperCase();
}

export function formatTRY(v) {
  const n = typeof v === "number" ? v : parseFloat(String(v || "0").replace(/[^\d.-]/g, ""));
  if (isNaN(n)) return "0";
  return n.toLocaleString("tr-TR", { maximumFractionDigits: 2 });
}

export function num(v) {
  if (v === null || v === undefined || v === "") return 0;
  if (typeof v === "number") return v;
  const t = String(v).replace("₺", "").replace(/\s/g, "");
  const s = !t.includes(",") && /^-?\d+\.\d{1,2}$/.test(t) ? t : t.replace(/\./g, "").replace(",", ".");
  const n = parseFloat(s);
  return isNaN(n) ? 0 : n;
}

export function fmtMoney(v) {
  if (v === null || v === undefined || v === "") return "";
  const s = String(v);
  const [i, d] = s.split(".");
  const int = (i || "").replace(/\D/g, "").replace(/^0+(?=\d)/, "");
  const g = int.replace(/\B(?=(\d{3})+(?!\d))/g, ".");
  return d !== undefined ? `${g},${d}` : g;
}

export const canonMoney = (v) => (v === "" || v === null || v === undefined ? "" : String(num(v)));

export function parseMoney(t) {
  const s = String(t || "").replace(/[^\d,]/g, "");
  const [i, ...r] = s.split(",");
  return r.length ? `${i}.${r.join("").slice(0, 2)}` : i;
}
